"use strict";

// Make sure that the name matches https://github.com/Credify/loan-review-client/blob/master/loan-review-srvc-model/src/main/java/com/credify/loanReview/enums/BrandName.java
module.exports = {
  UPGRADE_THEME_NAME: "upgrade",
  UPGRADE_DARK_THEME_NAME: "dark",
  UNIVERSAL_CREDIT_THEME_NAME: "universal_credit"
};
//# sourceMappingURL=themeNames.js.map